import { EditOutlined } from '@ant-design/icons';
import { Button } from 'antd';

interface EditButtonProps {
  onClick: () => void;
}

export const EditButton: React.FC<EditButtonProps> = ({ onClick }) => {
  return <Button icon={<EditOutlined />} onClick={onClick} />;
};
